import {DomainObject} from 'shared/store';
import { observable, computed, makeObservable } from 'mobx';
import _ from 'lodash';

class GroupBenefitCoverage extends DomainObject {
  coverageType;
  descriptions;
  subCategories;
  title;
  tooltip;

  constructor(other) {
    super();

    makeObservable(this, {
      coverageType: observable,
      descriptions: observable,
      subCategories: observable,
      title: observable,
      tooltip: observable,
      isOtherCoverage: computed,
      subCategoriesWithIndex: computed
    });

    this.merge(other);
  }

  get isOtherCoverage() {
    return this.coverageType === 'other';
  }

  get subCategoriesWithIndex() {
    return _.map(this.subCategories, (category, i) => {
      return {index: i + 1, ...category};
    });
  }
}
export default GroupBenefitCoverage;
